import { render, staticRenderFns } from "./RubensTubeViz.vue?vue&type=template&id=1041f619&scoped=true"
import script from "./RubensTubeViz.vue?vue&type=script&lang=js"
export * from "./RubensTubeViz.vue?vue&type=script&lang=js"
import style0 from "./RubensTubeViz.vue?vue&type=style&index=0&id=1041f619&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1041f619",
  null
  
)

export default component.exports